import { makeAutoObservable } from 'mobx';
import { validateCandlePattern } from './validateCandlePattern';

export class CandlePatternData {
  waitUntilCurrentCandleCloses = false;
  evaluateLookBackOnStart = true;
  evaluateLookBackOnRepeat = true;
  candleDuration = 1;
  breakBy = 0;
  breakByOnTrigger = 0;
  currentPattern = [];
  pattern = [];

  constructor(initialData) {
    makeAutoObservable(this);
    if (initialData) {
      Object.keys(initialData).forEach(
        (field) => (this[field] = initialData[field])
      );
    }
  }

  // common methods
  resetToDefaults = () => {
    this.waitUntilCurrentCandleCloses = false;
    this.evaluateLookBackOnStart = true;
    this.evaluateLookBackOnRepeat = true;
    this.candleDuration = 1;
    this.breakBy = 0;
    this.breakByOnTrigger = 0;
    this.currentPattern = [];
    this.pattern = [];
  };

  updateTactic = (dataObj) => {
    for (const key in dataObj) {
      this[key] = dataObj[key];
    }
  };

  validate = (tradePlan) => {
    const data = {
      pattern: this.pattern,
      tradePlan,
    };
    const validationResult = validateCandlePattern(data);
    return validationResult;
  };

  returnJson = () => {
    return {
      waitUntilCurrentCandleCloses: this.waitUntilCurrentCandleCloses,
      evaluateLookBackOnStart: this.evaluateLookBackOnStart,
      evaluateLookBackOnRepeat: this.evaluateLookBackOnRepeat,
      candleDuration: this.candleDuration,
      breakBy: this.breakBy,
      breakByOnTrigger: this.breakByOnTrigger,
      pattern: this.pattern,
    };
  };

  //specific methods
  setWaitUntilCandleCloses = (bool) => {
    this.waitUntilCurrentCandleCloses = bool;
  };
  setEvaluateLookBackOnStart = (bool) => {
    this.evaluateLookBackOnStart = bool;
  };
  setCandleDuration = (number) => {
    this.candleDuration = number;
  };
  setBreakBy = (number) => {
    this.breakBy = number;
  };
  setBreakByOnTrigger = (number) => {
    this.breakByOnTrigger = number;
  };
  addSequenceToCurrentPattern = (sequence) => {
    this.currentPattern.push(sequence);
    return this;
  };
  removeSequenceFromCurrentPattern = (index) => {
    const newCurrentPattern = this.currentPattern.filter(
      (_item, i) => i !== index
    );
    this.currentPattern = newCurrentPattern;
    return this;
  };
  addPatternToArray = () => {
    this.pattern.push(this.currentPattern);
    return this;
  };
  removePatternFromArray = (index) => {
    const newPatternArray = this.pattern.filter((_item, i) => i !== index);
    this.pattern = newPatternArray;
    return this;
  };
  clearCurrentPattern = () => {
    this.currentPattern = [];
    return this;
  };
  clearPatternArray = () => {
    this.pattern = [];
    return this;
  };
}

/* 
{
    "quantityBasis": "DOLLARS",
    "status": "ARMED",
    "dataSource": "LIVE",
    "brokerage": "BACKTEST",
    "accountNumber": "BACKTEST",
    "goLong": true,
    "goShort": false,
    "workOrders": false,
    "workOrdersOnEntry": true,
    "workOrdersOnExit": true,
    "strategy": "BASIC_TRADING_SYSTEM",
    "instrument": "stock",
    "symbol": "aapl",
    "startPeriod": "open",
    "setup": "CANDLE_PATTERN",
    "terminateWhenFlat": true,
    "restartSystemOncePositionHasFlattened": false,
    "flattenAtMarketClose": false,
    "startHour": 9,
    "startMin": 30,
    "evaluateQuotes": false,
    "persistTradePlanOnFailedFiltersOrValidation": false,
    "useDifferentWorkOrderFieldsOnExit": false,
    "getAwayOffsetPctOnExit": 0.1,
    "pctBetweenBidAskOnExit": 0.5,
    "pctIncreasePerOrderAttemptOnExit": 0.1,
    "useDifferentWorkOrderFieldsOnTarget": false,
    "getAwayOffsetPctOnTarget": 0.1,
    "pctBetweenBidAskOnTarget": 0.5,
    "pctIncreasePerOrderAttemptOnTarget": 0.1,
    "entryTactics": {
        "MARKET_ORDER": {
            "quantityBasisValue": "10000"
        }
    },
    "exitTactics": {
        "PRESERVE_PROFIT": {
            "amount": "100",
            "activationProfitAmount": "100"
        }
    },
    "setupDetails": {
        "CANDLE_PATTERN": {
            "waitUntilCurrentCandleCloses": false,
            "candleDuration": 1,
            "breakBy": 0,
            "breakByOnTrigger": 0,
            "pattern": [
                [
                    {
                        "terminateOnFail": false,
                        "restartOnFail": false,
                        "candleSequence": "BREAK_HIGH"
                    },
                    {
                        "terminateOnFail": false,
                        "restartOnFail": true,
                        "candleSequence": "BREAK_HIGH"
                    }
                ],
                [
                    {
                        "terminateOnFail": false,
                        "restartOnFail": false,
                        "candleSequence": "BREAK_HIGH"
                    },
                    {
                        "terminateOnFail": false,
                        "restartOnFail": true,
                        "candleSequence": "FAIL_TO_BREAK_HIGH"
                    },
                    {
                        "terminateOnFail": false,
                        "restartOnFail": true,
                        "candleSequence": "BREAK_HIGH"
                    }
                ],
                [
                    {
                        "terminateOnFail": false,
                        "restartOnFail": false,
                        "candleSequence": "BREAK_HIGH"
                    },
                    {
                        "terminateOnFail": false,
                        "restartOnFail": true,
                        "candleSequence": "INSIDE_CANDLE"
                    },
                    {
                        "terminateOnFail": false,
                        "restartOnFail": true,
                        "candleSequence": "BREAK_HIGH"
                    }
                ]
            ]
        }
    },
    "restartSettings": {
        "maxRestartAttempts": 0,
        "isMaxRestartAttempts": false,
        "maxLoss": 0,
        "isMaxLoss": false,
        "maxMinutesInTradePlan": 0,
        "isMaxMinutesInTradePlan": false,
        "numberOfTrades": 0,
        "isNumberOfTrades": false,
        "deactivateOnRestart": false
    },
    "savedConfigurationTitle": "candlePattern",
    "id": 1642531659550
}

{
    "messageType": "userPreferences",
    "json": "{\"exitTactics\":{\"PRESERVE_PROFIT\":{\"amount\":0,\"activationProfitAmount\":0}},\"quickTrade\":{\"instrument\":\"\",\"quantityBasis\":\"\",\"quantityBasisValue\":0,\"accountNumber\":\"\",\"dataSource\":\"LIVE\",\"brokerage\":\"\",\"optionDirection\":\"\",\"entryType\":\"\",\"limitOrder\":{\"offsetFromSetupPrice\":0,\"limitPrice\":0,\"quantityBasisValue\":0,\"setLimitFromSetupBreakPrice\":false},\"candleBreak\":{\"candleDuration\":1,\"quantityBasisValue\":0,\"waitUntilCurrentCandleCloses\":false,\"breakBy\":0},\"break\":{\"priceToBreak\":0},\"nearestOtmItm\":\"nearestOtm\",\"maxOptionPrice\":0,\"expirationWeeksAway\":0,\"notExpiringToday\":false,\"workOrders\":false,\"getAwayOffsetPct\":0.1,\"pctBetweenBidAsk\":0.5,\"pctIncreasePerOrderAttempt\":0.1},\"tradePlanConfig\":{\"status\":\"ARMED\",\"dataSource\":\"LIVE\",\"brokerage\":\"none\",\"accountNumber\":\"none\",\"goLong\":false,\"goShort\":false,\"workOrders\":true,\"workOrdersOnEntry\":true,\"workOrdersOnExit\":true,\"quantityBasis\":\"none\",\"strategy\":\"BASIC_TRADING_SYSTEM\",\"instrument\":\"stock\",\"symbol\":\"\",\"setup\":\"none\",\"terminateWhenFlat\":true,\"restartSystemOncePositionHasFlattened\":false,\"flattenAtMarketClose\":false,\"getAwayOffsetPct\":0.1,\"pctBetweenBidAsk\":0.5,\"pctIncreasePerOrderAttempt\":0.1,\"startHour\":9,\"startMin\":30,\"evaluateQuotes\":true,\"persistTradePlanOnFailedFiltersOrValidation\":false},\"optionManagement\":{\"optionChoices\":{},\"expirationDates\":[],\"buyOrSellOption\":\"LONG\",\"OTM\":false,\"ITM\":false,\"notExpiringToday\":false,\"optionChainStrategy\":{\"hugCurrentPrice\":{\"numOfStrikes\":5}},\"optionFilters\":{\"tightSpreadPct\":{\"maxOptionSpreadPct\":0.05}}},\"tradePlanDefaultEntryTactics\":{\"marketOrder\":{\"enabled\":false},\"limitOrder\":{\"enabled\":false,\"offset\":0,\"setLimitFromSetupBreakPrice\":false},\"candleBreak\":{\"enabled\":false,\"candleDuration\":0,\"waitUntilCurrentCandleCloses\":false,\"breakBy\":0},\"qtyBasisValues\":{\"dollarStock\":0,\"dollarOption\":0,\"qtyStock\":0,\"qtyOption\":0}},\"optionRadioButtons\":\"none\",\"defaultSavedTpConfigKey\":0,\"restartSettings\":{\"maxRestartAttempts\":0,\"isMaxRestartAttempts\":false,\"maxLoss\":0,\"isMaxLoss\":false,\"maxMinutesInTradePlan\":0,\"isMaxMinutesInTradePlan\":false,\"numberOfTrades\":0,\"isNumberOfTrades\":false,\"deactivateOnRestart\":false},\"userAlerts\":{\"isEmail\":false,\"isText\":false,\"isSoundAlert\":false}}"
}




*/
